/* eslint-disable max-lines-per-function */
import debounce from "lodash.debounce";
import { cn } from "tailwind-variants";
import { calculateSizes } from "./utils";
import { useDtfStore } from "../store";
import "./Quantity.scss";
import { renderList } from "common/vue/render-list";

export default function JerseyNumbersQuantity({ ...restProps }) {
  const MAX_QUANTITY = 999;
  const store = useDtfStore();

  function letterNumberArtwork() {
    return store.letterNumberArtwork;
  }

  const updatePricing = debounce(() => {
    const { quantity } = letterNumberArtwork();
    if (quantity) store.getArtworksPricing();
  }, 500);

  function handleChange(field, event) {
    const { value } = event.target;
    let quantity = value.replace(/[^0-9]/g, "").replace(/^0/, "");
    if (Number(quantity) > 0) {
      quantity = Math.min(Number(quantity), MAX_QUANTITY);
    }
    event.target.value = quantity;
    const quantities = Object.entries({
      ...letterNumberArtwork().quantities,
      [field]: quantity
    }).reduce((acc, [number, qty]) => {
      if (qty) {
        acc[number] = qty;
      }
      return acc;
    }, {});
    const totalQuantity = Object.values(quantities).reduce((acc, curr) => acc + Number(curr), 0);
    const style = letterNumberArtwork().style || "none";
    const sizes = calculateSizes({
      ...letterNumberArtwork(),
      quantities,
      style
    });
    const width = Object.values(sizes)
      .reduce((sum, current) => sum + current.width, 0)
      .toFixed(2);
    store.updateArtworkValues({
      index: 0,
      quantities,
      quantity: totalQuantity,
      sizes,
      width
    });
    updatePricing();
  }

  function handleBlur() {
    store.updatePdpDates();
  }

  return (
    <div {...restProps} className={cn("jersey-numbers-quantity", restProps.className)}>
      {renderList(10, n => (
        <div className="jersey-numbers-quantity__field" key={n}>
          <label
            className="jersey-numbers-quantity__label"
            htmlFor={`input-${n}`}
            data-testid="jersey-numbers-quantity-label"
          >
            #{n - 1}
          </label>
          <input
            className="jersey-numbers-quantity__input"
            id={`input-${n}`}
            value={letterNumberArtwork().quantities[n - 1]}
            maxLength={3}
            type="tel"
            onInput={e => {
              handleChange(n - 1, e);
            }}
            onBlur={handleBlur}
            data-testid="jersey-numbers-quantity-input"
          />
        </div>
      ))}
    </div>
  );
}
